import moment from "moment";
import React from "react";
import { withTranslation } from "react-i18next";
import { debug } from "../../App";
import { InputFactory } from "../Factories/Input";

class Datetime extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      time: null,
      date: null,
    };
  }

  handleChange(event: any) {
    const stateTemp: any = {};
    if (event.detail.value !== undefined) {
      const name = event?.target ? event.target.name : event.detail.name;
      stateTemp[name] = event.detail.value;
    } else {
      delete stateTemp[event.detail.name];
    }
    this.setState(stateTemp, () => {
      debug(this.state);
      const date = this.state.date ? this.state.date : moment().format("YYYY-MM-DD");
      const datetime = moment(`${date} ${this.state.time}`, "YYYY-MM-DD HH:mm:ss").utc().format();
      const ionEvent = new CustomEvent("ionChange", {
        detail: {
          name: this.props.name,
          value: datetime,
        },
      });
      this.props.onIonChange(ionEvent);
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className={this.props.className && this.props.className}>
        <div className="input__container input__container--type-date">
          <InputFactory
            name="date"
            type="date"
            placeholder={`${t("date")}*`}
            onIonChange={this.handleChange.bind(this)}
            className="input__input input-factory__input input-factory__input--type-date"
          />
        </div>
        <div className="input__container input__container--type-time">
          <InputFactory
            name="time"
            type="time"
            placeholder={`${t("time")}*`}
            onIonChange={this.handleChange.bind(this)}
            className="input__input input-factory__input input-factory__input--type-time"
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Datetime);
